<template>
    <div class="vrm-spinner">
        <img class="vrm-spinner__image" src="/img/svg-icons/loading-spinner-blue.svg" />
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('spinner')
export default class Spinner extends Vue {}
</script>
